
import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export const getTurnos = (id_ruta, setTurnos) => {
    api.get(`${apiUrl}/monitor/programacion/consulta-esquemas?id_ruta=${id_ruta}`).then((res) => {
      
        setTurnos(res.data)

    })
        .catch((error) => {
            console.log("error", error);

        })
}

export const getTurnosEnGeneral = (setTurnos) => {
    api.get(apiUrl + `/monitor/getTurnos`).then((res) => {
        setTurnos(res.data)
    })
        .catch((error) => {
            console.log("error", error);

        })
}
export const getTipo = (setTipo) => {
    api.get(apiUrl + `/monitor/getTipo`).then((res) => {
        setTipo(res.data)
    })
        .catch((error) => {
            console.log("error", error);

        })
}